module.exports = __webpack_public_path__ + "img/9788992579919.5e22ef3f.jpg";